<template>
  <div v-if="showNoResult" class="search-msn no-results-box">
    <div class="fullscreen-center">
      <icon-base class="mb-2" width="90" height="90">
        <d-icon-no-result />
      </icon-base>
      <p class="no-results-found" :class="{ 'dark-text': light }">
        {{ $t("explorer.noSearchResult") }}
        <!-- No results found... -->
      </p>
      <p v-if="!notSearch" class="please-try-searchin">
        ({{ $t("explorer.trySearchAgain") }})
        <!-- (Please try searching again) -->
      </p>
    </div>
  </div>
</template>
<script>
import IconBase from "../IconBase.vue";
import DIconNoResult from "../icons/colored/DIconNoResult.vue";
export default {
  name: "DNoResult",
  props: {
    showNoResult: Boolean,
    notSearch: Boolean,
    light: Boolean,
  },
  components: {
    IconBase,
    DIconNoResult,
  },
};
</script>

<style scoped>
.search-msn {
  animation: delay 0.7s;
  animation-iteration-count: 1;
  /* Safari and Chrome: */
  -webkit-animation: delay 0.7s;
  -webkit-animation-iteration-count: 1;
}
@keyframes delay {
  0% {
    opacity: 0;
  }
  70% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes delay {
  0% {
    opacity: 0;
  }
  70% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.no-results-box {
  position: relative;
  height: 100%;
  width: 100%;
  pointer-events: none;
}
.fullscreen-center {
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.no-results-found {
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  margin: 0;
}
.dark-text {
  color: #3f3f3f;
}
.please-try-searchin {
  color: #8d909f;
  font-size: 16px;
  text-align: center;
}
</style>
